import { Component, inject, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { PaymentsService } from '../../../services/payments.service'
import { eps } from '../../../services/url.service'

@Component({
  selector: 'app-payment-callback',
  imports: [],
  templateUrl: './payment-callback.component.html',
  styleUrl: './payment-callback.component.scss'
})
export class PaymentCallbackComponent implements OnInit {
  private route = inject(ActivatedRoute)
  private router = inject(Router)
  private paymentsService = inject(PaymentsService)

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const paymentData = {
        razorpay_payment_id: params['razorpay_payment_id'],
        razorpay_payment_link_id: params['razorpay_payment_link_id'],
        razorpay_payment_link_reference_id: params['razorpay_payment_link_reference_id'],
        razorpay_payment_link_status: params['razorpay_payment_link_status'],
        razorpay_signature: params['razorpay_signature']
      }

      if (!paymentData.razorpay_payment_id) {
        this.router.navigate([eps.planAndBilling.paymentFailurePath], {
          queryParams: { error: 'Invalid callback data.' }
        })
        return
      }

      // Send this data to your backend for verification
      this.paymentsService.verifyRedirectPayment(paymentData).subscribe({
        next: response => {
          if (response.status === 'success') {
            this.router.navigate([eps.planAndBilling.paymentSuccessPath])
          } else {
            this.router.navigate([eps.planAndBilling.paymentFailurePath])
          }
        },
        error: err => {
          // Redirect to a final failure page
          this.router.navigate([eps.planAndBilling.paymentFailurePath])
        }
      })
    })
  }
}
